export enum MenuPosition {
  TOP,
  BOTTOM,
}
